import { FORM_KEY } from 'constants/form-ids';
import { PaymentStatus } from 'constants/payment';
import { useAppSelector } from 'store/hooks';
import { CardForm } from 'views/forms/bet-city/card-form';
import { Fade } from 'views/shared/fade';
import { LoadingState } from 'views/shared/loading-state';

import { CheckError } from '../check-error';
import { CheckSuccess } from '../check-success';
import { BaseCard } from '../ui/base-card';

const BaseCardWrapper = () => {
  const { paymentData } = useAppSelector((state) => state.payment);
  const renderBaseCard = () => {
    switch (paymentData?.status) {
      case PaymentStatus.WAIT_PAYMENT:
      case PaymentStatus.WAIT_PAYMENT_CONFIRM:
      case PaymentStatus.WAIT_EXTERNAL_PAYSYSTEM:
      case PaymentStatus.WAIT_AMOUNT_CONFIRM:
        return (
          <BaseCard>
            <CardForm />
          </BaseCard>
        );
      case PaymentStatus.PAYMENT_SUCCESS:
      case PaymentStatus.WAIT_PROCESSING:
        return <CheckSuccess />;
      case PaymentStatus.PAYMENT_FAILED:
      case PaymentStatus.PAYMENT_NOTFOUND:
      case PaymentStatus.INTERNAL_ERROR:
      case PaymentStatus.INVOICE_DISABLED:
      case PaymentStatus.RETRYABLE_FAILED:
      case PaymentStatus.PAYMENT_TIMEOUT:
      case PaymentStatus.INCORRECT_DATA:
      case PaymentStatus.ANTIFROD_DECLINED:
        return <CheckError />;
      default:
        return (
          <div className="w-full flex-grow items-center flex justify-center">
            <LoadingState formKey={FORM_KEY.BET_CITY} />
          </div>
        );
    }
  };

  return <Fade className="w-full h-full flex">{renderBaseCard()}</Fade>;
};

export { BaseCardWrapper };
